import React from 'react';
import { Box, SimpleGrid, Flex } from '@chakra-ui/react';
import ProductCardSkeleton from './ProductCardSkeleton';

const CategorySectionSkeleton = () => {
  return (
    <Box py={12} px={{ base: 4, md: 8, lg: 16 }} bg="gray.50">
      {/* Desktop View */}
      <SimpleGrid 
        columns={{ base: 1, sm: 2, md: 3, lg: 4 }} 
        spacing={8}
        display={{ base: 'none', md: 'grid' }}
      >
        {Array.from({ length: 4 }).map((_, index) => (
          <ProductCardSkeleton key={index} />
        ))}
      </SimpleGrid>

      {/* Mobile View */}
      <Flex
        display={{ base: 'flex', md: 'none' }}
        overflowX="auto"
        whiteSpace="nowrap"
        sx={{
          '&::-webkit-scrollbar': { display: 'none' },
          '-ms-overflow-style': 'none',
          'scrollbar-width': 'none',
        }} // Hide scrollbar
      >
        {Array.from({ length: 2 }).map((_, index) => (
          <Box key={index} minW={{ base: '280px', sm: '300px' }} mr={4} flexShrink={0} p={2}>
            <ProductCardSkeleton />
          </Box>
        ))}
      </Flex>
    </Box>
  );
};

export default CategorySectionSkeleton;
